import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SearchContentContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  left: ${216 * Screen.widthRatio}px;
  position: absolute;
  top: ${-150 * Screen.widthRatio}px;
`;

export default SearchContentContainer;
